import { createFileRoute, redirect } from "@tanstack/react-router";
import { PublicEventPage } from "@/features/event-explorer/components/PublicEventPage";
import { authApi } from "@/lib/humhub-api/auth";
import { eventsApi } from "@/lib/humhub-api/events";

export const Route = createFileRoute("/public-event/$event-code")({
  beforeLoad: async ({ params }) => {
    const code = params["event-code"];

    // イベント情報を取得
    const event = await eventsApi.getPublicEventByCode(code);
    if (!event?.id) return;

    // ログイン状態をチェック（認証エラーは無視、redirectエラーは自然に外に出る）
    let isLoggedIn = false;
    try {
      const me = await authApi.getCurrentUser();
      isLoggedIn = !!me;
    } catch (authError) {
      // 認証エラーは無視
      console.warn("Auth check failed:", authError);
    }

    // ログイン済みならリダイレクト（この時点でredirectエラーが発生すれば自然に外に出る）
    if (isLoggedIn) {
      throw redirect({
        to: "/event-search/code/$event-code",
        params: { "event-code": String(event.code) },
        replace: true,
      });
    }
  },

  loader: async ({ params }) => {
    const code = params["event-code"];
    return { eventCode: code };
  },

  staleTime: 0,
  component: PublicEventPage,
});
